var CategoryMenuButton          = require("./CategoryMenuButton"),
    RepeaterArrayDataAdapter    = require("enyo-ui/RepeaterArrayDataAdapter"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    SimpleRepeater              = require("enyo-ui/SimpleRepeater"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    kind                        = require("enyo/kind");

require("app/theme/ScrollerDecoratorScrollbars--header.less");

module.exports = kind(/** @lends  app.AppHeader.CategoryMenu.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.CategoryMenu",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    classes: "app-app-header-category-menu",

    /**
     * The state of this menu.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * The theme to use for this decorator.
     *
     * @type  {?string}
     * @public
     */
    theme: "header",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:           "scroller",
        kind:           Scroller,
        classes:        "app-app-header-category-menu__scroller",
        vertical:       true,
        horizontal:     false,
        scrollChaining: false,
        components:     [{
            name:            "repeater",
            kind:            SimpleRepeater,
            classes:         "app-app-header-category-menu__repeater",
            dataAdapterKind: RepeaterArrayDataAdapter,

            /**
             * The kind that will be rendered for each item in the dataset.
             *
             * @type  {enyo.Control}
             * @public
             */
            childKind: CategoryMenuButton
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state = this.state || {};

        this.$.repeater.set("data", state.categories || []);
    }

});
